import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import styles from '../FilterSidebar.module.css';
import classnames from 'classnames';
import { connect } from 'react-redux';
import React, { Fragment } from 'react';
import { ReactComponent as CircleLegend } from '../../../assets/images/circle.svg';
import { onChangeCurrentScootersFilter } from '../../../ac/onChangeMapFilters';
import { CurrentScootersFilterValues } from '../../../constants/variables';
import { LegendRenderer } from '../../LegendRenderer/LegendRenderer';
import { CUR_SCOOTERS_PARKING_GRADIENT_LEGEND } from '../../../constants/legends';

const CurrentScootersComponent = ({
    mapFilters,
    onChangeCurrentScootersFilter,
}) => (
    <div>
        <span className={styles.legendSubtitle}>{t`Кол-во самокатов на парковке`}:</span>
        <div className={styles.checkboxIconGrid}>
            {
                CurrentScootersFilterValues.map(({ value, fill, label }) => (
                    <Fragment key={value}>
                        <CircleLegend
                            fill={fill}
                            width='2vw'
                            height='2vw'
                            opacity='0.8'
                        />
                        <label htmlFor={label.id}>{i18n._(label)}</label>
                        <div>
                            <label className={styles.switch}>
                                <input
                                    type='checkbox'
                                    name='poi'
                                    id={value}
                                    checked={mapFilters.currentScootersStatuses.includes(value)}
                                    value={value}
                                    onChange={onChangeCurrentScootersFilter}
                                />
                                <span className={classnames(styles.sliderRound, styles.slider)} />
                            </label>
                        </div>
                    </Fragment>
                ))
            }
        </div>
    </div>
);
const CurScootresParkingLegendComponent = () => (
    <LegendRenderer config={CUR_SCOOTERS_PARKING_GRADIENT_LEGEND} />
);
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(mapStateToProps, { onChangeCurrentScootersFilter })(CurrentScootersComponent);
export const CurScootresParkingLegend = withDisplayedLayersCheck(CurScootresParkingLegendComponent, t`Количество самокатов на парковках`);
export const CurrentScootersFilter = withDisplayedLayersCheck(ConnectedComponent, t`Количество самокатов на парковках`);
